export const useHeader = (state) => {
    const {
        $gsap: gsap,
        $ScrollTrigger: ScrollTrigger
    } = useNuxtApp();

    const header = document.querySelector('.p-header');
    const hero = document.querySelector('[data-is-hero]')
    const withHero = document.body.classList.contains('w-hero');
    const darker = document.body.classList.contains('darker');

    const setTheme = (theme, bg, hero = 'false') => {
        document.body.dataset.headerTheme = theme;
        document.body.dataset.headerThemeBg = bg;
        document.body.dataset.scrolledHero = hero;
    }

    if (state) {
        gsap.to(header, {
            duration: 0.35,
            delay: 0.2,
            opacity: 1,
            ease: "power4.in"
        });

        if (withHero) {
            const headerHeight = `${(header.scrollHeight / 16)}rem`;
            const mode = darker ? 'dark' : 'light';
            setTheme(mode, 'transparent', 'true');

            ScrollTrigger.create({
                trigger: hero,
                invalidateOnRefresh: true,
                start: () => `0% ${headerHeight}`,
                end: () => `100% ${headerHeight}`,
                onEnter: () => setTheme(mode, 'transparent', 'false'),
                onEnterBack: () => setTheme(mode, 'transparent', 'false'),
                onLeave: () => setTheme('dark', 'white', 'true'),
                onLeaveBack: () => setTheme('dark', 'white', 'true'),
            });

        } else {
            setTheme('dark', 'white');
        }
    } else {
        gsap.set(header, {
            duration: .2,
            ease: 'elastic.out',
            opacity: 0
        });
    }
}